module.exports = __webpack_public_path__ + "6cba88684b43ca192044f54e4e27fdc7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-2.png
 ** module id = 1010
 ** module chunks = 0
 **/